"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BACK_BUTTON_LABEL", {
  enumerable: true,
  get: function get() {
    return _editorButtons.BACK_BUTTON_LABEL;
  }
});
Object.defineProperty(exports, "CANCEL_BUTTON_LABEL", {
  enumerable: true,
  get: function get() {
    return _editorButtons.CANCEL_BUTTON_LABEL;
  }
});
exports.ProposalEditor = exports.NOT_ALL_TRACKED_CHANGES_SHOWN = exports.EDIT_BOX_REVIEW_HEADING = exports.DELETED_ROW_TITLE = void 0;
Object.defineProperty(exports, "SAVE_BUTTON_LABEL", {
  enumerable: true,
  get: function get() {
    return _editorButtons.SAVE_BUTTON_LABEL;
  }
});
exports.STRUCK_TEXT_HINT = void 0;
Object.defineProperty(exports, "SYNCING_WITH_DOCUMENT_LABEL", {
  enumerable: true,
  get: function get() {
    return _editorButtons.SYNCING_WITH_DOCUMENT_LABEL;
  }
});
exports.bookmarksTheEditBoxReads = bookmarksTheEditBoxReads;
var _react = _interopRequireWildcard(require("react"));
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _proposedRevisions = require("@common/utils/redline/ooxml/proposed-revisions");
var _AppliedRedlineDocumentation = require("../../redline/AppliedRedlineDocumentation");
var _RevisionLegend = _interopRequireDefault(require("../../redline/RevisionLegend"));
var _editBoxRead = require("./edit-box-read");
var _EditableRedlineParagraph = require("./EditableRedlineParagraph");
var _editableTableModel = require("./editable-table-model");
var _EditorActions = require("./EditorActions");
var _reportEditBoxFailure = require("./report-edit-box-failure");
var _jsxRuntime = require("react/jsx-runtime");
var _editorButtons = require("./editor-buttons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var STRUCK_TEXT_HINT = exports.STRUCK_TEXT_HINT = "Struck text is removed by the proposal. Click it to put it back.";
var NOT_ALL_TRACKED_CHANGES_SHOWN = exports.NOT_ALL_TRACKED_CHANGES_SHOWN = "Not all tracked changes shown";
var EDIT_BOX_REVIEW_HEADING = exports.EDIT_BOX_REVIEW_HEADING = "This is what Save writes to the document.";
var DELETED_ROW_TITLE = exports.DELETED_ROW_TITLE = "Click to keep this row";
var INSERTED_ROW_BACKGROUND = "#f0fdf4";
var DELETED_ROW_BACKGROUND = "#fef2f2";
function rowStyleOf(revision, proposalColor) {
  if (revision === "inserted") return {
    background: INSERTED_ROW_BACKGROUND,
    borderLeft: "3px solid ".concat(proposalColor)
  };
  if (revision === "deleted") return {
    background: DELETED_ROW_BACKGROUND,
    borderLeft: "3px solid ".concat(proposalColor),
    textDecoration: "line-through"
  };
  return undefined;
}
function pageReadOf(textRedline, textRedlineBeforeEdit, proposalPackageOoxml, proposalStampedAt) {
  return {
    kind: "pageRead",
    packageOoxml: proposalPackageOoxml,
    stampedAt: proposalStampedAt,
    cardOfRead: (0, _editableTableModel.liveParagraphTextsOf)(textRedlineBeforeEdit !== null && textRedlineBeforeEdit !== void 0 ? textRedlineBeforeEdit : textRedline, proposalPackageOoxml, proposalStampedAt)
  };
}
function openedEditBoxStateOf(_ref) {
  var textRedline = _ref.textRedline,
    textRedlineBeforeEdit = _ref.textRedlineBeforeEdit,
    textRedlineWhenOpened = _ref.textRedlineWhenOpened,
    proposalPackageOoxml = _ref.proposalPackageOoxml,
    proposalStampedAt = _ref.proposalStampedAt;
  var textRedlineSavedEditWasMadeOver = textRedlineBeforeEdit === null ? textRedline : textRedlineWhenOpened !== null && textRedlineWhenOpened !== void 0 ? textRedlineWhenOpened : textRedlineBeforeEdit;
  var openedOnSavedText = {
    packageOoxml: null,
    packageStampedAt: null,
    textRedlineBoxReads: textRedlineSavedEditWasMadeOver,
    draft: textRedline,
    draftBeforeUserTyped: textRedline,
    keptUsersWordsOverRead: false,
    pageReadCarryOverFailures: 0,
    lastPageReadCarryOverError: null
  };
  return editBoxStateAfter(openedOnSavedText, pageReadOf(textRedline, textRedlineBeforeEdit, proposalPackageOoxml, proposalStampedAt));
}
function sameCard(left, right) {
  return JSON.stringify(left) === JSON.stringify(right);
}
function editBoxStateAfterPageRead(state, action) {
  var cardOfRead = action.cardOfRead;
  if (cardOfRead === null || sameCard(cardOfRead, state.textRedlineBoxReads)) {
    var sameRead = action.packageOoxml === state.packageOoxml && action.stampedAt === state.packageStampedAt;
    return sameRead ? state : _objectSpread(_objectSpread({}, state), {}, {
      packageOoxml: action.packageOoxml,
      packageStampedAt: action.stampedAt
    });
  }
  try {
    var carried = (0, _editBoxRead.draftCarriedOverRead)(state.textRedlineBoxReads, state.draft, cardOfRead);
    return _objectSpread(_objectSpread({}, state), {}, {
      packageOoxml: action.packageOoxml,
      packageStampedAt: action.stampedAt,
      textRedlineBoxReads: cardOfRead,
      draft: carried.draft,
      draftBeforeUserTyped: (0, _editBoxRead.draftCarriedOverRead)(state.textRedlineBoxReads, state.draftBeforeUserTyped, cardOfRead).draft,
      keptUsersWordsOverRead: state.keptUsersWordsOverRead || carried.keptUsersWordsOverRead
    });
  } catch (error) {
    return _objectSpread(_objectSpread({}, state), {}, {
      pageReadCarryOverFailures: state.pageReadCarryOverFailures + 1,
      lastPageReadCarryOverError: error
    });
  }
}
function editBoxStateAfter(state, action) {
  switch (action.kind) {
    case "textTyped":
      return _objectSpread(_objectSpread({}, state), {}, {
        draft: (0, _editableTableModel.withTargetText)(state.draft, action.target, action.text)
      });
    case "rowKept":
      return _objectSpread(_objectSpread({}, state), {}, {
        draft: (0, _editableTableModel.withRowDeletionRestored)(state.draft, action.deletion)
      });
    case "pageRead":
      return editBoxStateAfterPageRead(state, action);
  }
}
function bookmarksTheEditBoxReads(textRedline, textRedlineBeforeEdit) {
  return (textRedlineBeforeEdit !== null && textRedlineBeforeEdit !== void 0 ? textRedlineBeforeEdit : textRedline).paragraphs.flatMap(function (paragraph) {
    return paragraph.bookmark === null ? [] : [paragraph.bookmark];
  });
}
function reviewOfBox(box) {
  if (!box.keptUsersWordsOverRead || box.packageOoxml === null || box.packageStampedAt === null) return null;
  return {
    draft: box.draft,
    textRedlineBoxReads: box.textRedlineBoxReads,
    packageOoxml: box.packageOoxml,
    stampedAt: box.packageStampedAt
  };
}
var ProposalEditor = exports.ProposalEditor = function ProposalEditor(_ref2) {
  var textRedline = _ref2.textRedline,
    textRedlineBeforeEdit = _ref2.textRedlineBeforeEdit,
    textRedlineWhenOpened = _ref2.textRedlineWhenOpened,
    author = _ref2.author,
    proposalPackageOoxml = _ref2.proposalPackageOoxml,
    proposalStampedAt = _ref2.proposalStampedAt,
    syncing = _ref2.syncing,
    renderReview = _ref2.renderReview,
    actionsSlot = _ref2.actionsSlot,
    _onSave = _ref2.onSave,
    onCancel = _ref2.onCancel;
  var _useReducer = (0, _react.useReducer)(editBoxStateAfter, {
      textRedline: textRedline,
      textRedlineBeforeEdit: textRedlineBeforeEdit,
      textRedlineWhenOpened: textRedlineWhenOpened,
      proposalPackageOoxml: proposalPackageOoxml,
      proposalStampedAt: proposalStampedAt
    }, openedEditBoxStateOf),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    box = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    reviewing = _useState2[0],
    setReviewing = _useState2[1];
  var review = (0, _react.useMemo)(function () {
    return renderReview === null ? null : reviewOfBox(box);
  }, [box, renderReview]);
  var composingRef = (0, _react.useRef)(false);
  var pageReadHeldWhileComposingRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (box.pageReadCarryOverFailures === 0) return;
    (0, _reportEditBoxFailure.reportEditBoxFailure)(box.lastPageReadCarryOverError, "carry the draft over the page read");
  }, [box.pageReadCarryOverFailures, box.lastPageReadCarryOverError]);
  (0, _react.useEffect)(function () {
    var pageRead;
    try {
      pageRead = pageReadOf(textRedline, textRedlineBeforeEdit, proposalPackageOoxml, proposalStampedAt);
    } catch (error) {
      (0, _reportEditBoxFailure.reportEditBoxFailure)(error, "read the live paragraph texts");
      return;
    }
    if (composingRef.current) {
      pageReadHeldWhileComposingRef.current = pageRead;
      return;
    }
    dispatch(pageRead);
  }, [textRedline, textRedlineBeforeEdit, proposalPackageOoxml, proposalStampedAt]);
  var takeComposing = function takeComposing(composing) {
    composingRef.current = composing;
    var heldPageRead = pageReadHeldWhileComposingRef.current;
    if (composing || heldPageRead === null) return;
    pageReadHeldWhileComposingRef.current = null;
    dispatch(heldPageRead);
  };
  var draft = box.draft;
  var before = box.textRedlineBoxReads;
  var draftIsUnchanged = sameCard(draft, box.draftBeforeUserTyped);
  var proposalColor = (0, _EditableRedlineParagraph.proposalColorOf)();
  var blocks = (0, _editableTableModel.editableBlocksOf)(box.packageOoxml, before);
  var showsStruckTextHint = before.paragraphs.some(function (paragraph) {
    return paragraph.textWhenProposed !== paragraph.textProposed;
  }) || before.tableChanges.rowDeletions.length > 0;
  function renderParagraphBlock(block, key, readOnly) {
    var target = block.target;
    if (readOnly) return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "whitespace-pre-wrap",
      children: block.textBeforeChanges
    }, key);
    if (target === null) return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "whitespace-pre-wrap",
      children: block.text
    }, key);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditableRedlineParagraph.EditableRedlineParagraph, {
      origin: (0, _editableTableModel.originOfTarget)(before, target),
      text: (0, _editableTableModel.textOfTarget)(draft, target),
      textBoxReads: (0, _editableTableModel.textOfTarget)(box.textRedlineBoxReads, target),
      proposalColor: proposalColor,
      ariaLabel: (0, _editableTableModel.targetLabelOf)(target),
      allowsLineBreaks: false,
      onChange: function onChange(text) {
        return dispatch({
          kind: "textTyped",
          target: target,
          text: text
        });
      },
      onComposingChange: takeComposing,
      "data-sentry-element": "EditableRedlineParagraph",
      "data-sentry-component": "renderParagraphBlock",
      "data-sentry-source-file": "ProposalEditor.tsx"
    }, (0, _editableTableModel.targetKeyOf)(target));
  }
  function renderRow(row, rowIndex) {
    var deletesThisRow = row.deletion !== null && (0, _editableTableModel.deletesRow)(draft, row.deletion);
    var revisionShown = deletesThisRow ? "deleted" : row.revision === "deleted" ? "none" : row.revision;
    var deletion = row.deletion;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
      style: rowStyleOf(revisionShown, proposalColor),
      className: deletesThisRow ? "cursor-pointer" : undefined,
      title: deletesThisRow ? DELETED_ROW_TITLE : undefined,
      onClick: deletesThisRow && deletion !== null ? function () {
        return dispatch({
          kind: "rowKept",
          deletion: deletion
        });
      } : undefined,
      "data-sentry-component": "renderRow",
      "data-sentry-source-file": "ProposalEditor.tsx",
      children: row.cells.map(function (cell, cellIndex) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
          colSpan: cell.columnSpan > 1 ? cell.columnSpan : undefined,
          className: "border border-[#d4d3d0] px-2 py-1 align-top",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col gap-2",
            children: renderBlocks(cell.blocks, deletesThisRow)
          })
        }, cellIndex);
      })
    }, rowIndex);
  }
  function renderTableBlock(block, key) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("table", {
      className: "my-1 w-full border-collapse",
      "data-sentry-component": "renderTableBlock",
      "data-sentry-source-file": "ProposalEditor.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
        children: block.rows.map(renderRow)
      })
    }, key);
  }
  function renderHintLine() {
    if (!showsStruckTextHint && !box.keptUsersWordsOverRead) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "text-[11px] text-[#686766]",
      "data-sentry-component": "renderHintLine",
      "data-sentry-source-file": "ProposalEditor.tsx",
      children: [showsStruckTextHint ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: STRUCK_TEXT_HINT
      }) : null, showsStruckTextHint && box.keptUsersWordsOverRead ? " " : null, box.keptUsersWordsOverRead ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        role: "status",
        className: "text-[#B45309]",
        children: NOT_ALL_TRACKED_CHANGES_SHOWN
      }) : null]
    });
  }
  function renderBlocks(shown, readOnly) {
    return shown.map(function (block, index) {
      return block.kind === "paragraph" ? renderParagraphBlock(block, "paragraph-".concat(index), readOnly) : renderTableBlock(block, "table-".concat(index));
    });
  }
  var reviewShown = reviewing && review !== null && renderReview !== null;
  var saveOpensReview = review !== null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlineAuthorColorsContext.InsideRedlinePreview, {
    "data-sentry-element": "InsideRedlinePreview",
    "data-sentry-component": "ProposalEditor",
    "data-sentry-source-file": "ProposalEditor.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col gap-2 cursor-default",
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      onKeyDown: function onKeyDown(event) {
        return event.stopPropagation();
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: reviewShown ? "hidden" : "flex flex-col gap-2",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RevisionLegend.default, {
          ooxml: (0, _AppliedRedlineDocumentation.legendOoxmlForAuthor)(_proposedRevisions.PROPOSED_REVISIONS_AUTHOR),
          alwaysListedAuthors: [author],
          "data-sentry-element": "RevisionLegend",
          "data-sentry-source-file": "ProposalEditor.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex flex-col gap-2 py-1",
          children: renderBlocks(blocks, false)
        }), renderHintLine()]
      }), reviewShown ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "text-[11px] font-medium text-[#686766]",
          children: EDIT_BOX_REVIEW_HEADING
        }), renderReview(review)]
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditorActions.EditorActions, {
        slot: actionsSlot,
        saveDisabled: draftIsUnchanged,
        syncing: syncing,
        onSave: function onSave() {
          if (saveOpensReview && !reviewShown) {
            setReviewing(true);
            return;
          }
          _onSave(draft, box.textRedlineBoxReads);
        },
        onBack: reviewShown ? function () {
          return setReviewing(false);
        } : null,
        onCancel: onCancel,
        "data-sentry-element": "EditorActions",
        "data-sentry-source-file": "ProposalEditor.tsx"
      })]
    })
  });
};